import { createAction } from '@ngrx/store';

import { SkuQuantityType } from 'ish-core/models/product/product.model';
import { httpError, payload } from 'ish-core/utils/ngrx-creators';

import { QuickOrder, UpdateQuickOrderItem } from '../../models/custom-quickorder/custom-quickorder.model';

export const loadQuickOrder = createAction('[QuickOrder] Load QuickOrder');

export const loadQuickOrderFail = createAction('[QuickOrder] Load QuickOrder Fail', httpError());

export const loadQuickOrderSuccess = createAction(
  '[QuickOrder] Load QuickOrder Success',
  payload<{ quickOrder: QuickOrder }>()
);

export const createQuickOrderItems = createAction(
  '[QuickOrder] Create QuickOrder Item(s)',
  payload<{ quickOrderItems: UpdateQuickOrderItem[] }>()
);

export const createQuickOrderItemsSuccess = createAction(
  '[QuickOrder] Create QuickOrder Items(s) success',
  payload<{ quickOrder: QuickOrder }>()
);
export const createQuickOrderItemsFail = createAction('[QuickOrder] Create QuickOrder Items(s) fail', httpError());

export const updateQuickOrderItem = createAction(
  '[QuickOrder] Update QuickOrder Item',
  payload<{ itemId: string; quickOrderItem: UpdateQuickOrderItem }>()
);

export const updateQuickOrderItemSuccess = createAction(
  '[QuickOrder] Update QuickOrder Item Success',
  payload<{ quickOrder: QuickOrder }>()
);

export const updateQuickOrderItemFail = createAction('[QuickOrder] Update QuickOrder Item Fail', httpError());

export const deleteQuickOrderItems = createAction(
  '[QuickOrder] Delete QuickOrder Items',
  payload<{ itemIds: string[] }>()
);

export const deleteQuickOrderItemsSuccess = createAction(
  '[QuickOrder] Delete QuickOrder Items Success',
  payload<{ quickOrder: QuickOrder }>()
);

export const deleteQuickOrderItemsFail = createAction('[QuickOrder] Delete QuickOrder Items Fail', httpError());

export const resetQuickOrderState = createAction('[QuickOrder] Reset QuickOrder');

export const addQuickOrderItemsToBasket = createAction(
  '[QuickOrder] Add QuickOrder Items to Basket',
  payload<{ items: SkuQuantityType[] }>()
);

export const addQuickOrderItemsToBasketSuccess = createAction('[QuickOrder] Add QuickOrder Items to Basket Success');

export const addQuickOrderItemsToBasketFail = createAction(
  '[QuickOrder] Add QuickOrder Items to Basket Fail',
  httpError()
);

export const addQuickOrderFlyOutItemsToBasket = createAction(
  '[QuickOrder] Add QuickOrder Flyout Items to Basket',
  payload<{ items: SkuQuantityType[] }>()
);

export const addQuickOrderFlyOutItemsToBasketSuccess = createAction(
  '[QuickOrder] Add QuickOrder Flyout Items to Basket Success'
);

export const addQuickOrderFlyOutItemsToBasketFail = createAction(
  '[QuickOrder] Add QuickOrder Flyout Items to Basket Fail',
  httpError()
);

export const deleteQuickOrder = createAction('[QuickOrder] Delete QuickOrder', payload<{ orderTemplateId: string }>());

export const deleteQuickOrderSuccess = createAction('[QuickOrder] Delete QuickOrder Success');

export const deleteAnonymousQuickOrder = createAction('[QuickOrder] Delete Anonymous QuickOrder');

export const deleteQuickOrderFail = createAction('[QuickOrder] Delete QuickOrder Fail', httpError());

export const createQuickOrderFlyoutItems = createAction(
  '[QuickOrder] Create QuickOrder Flyout Item(s)',
  payload<{ quickOrderItems: UpdateQuickOrderItem[] }>()
);

export const createQuickOrderFlyoutItemsSuccess = createAction(
  '[QuickOrder] Create QuickOrder Flyout Items(s) success',
  payload<{ quickOrder: QuickOrder }>()
);
export const createQuickOrderFlyoutItemsFail = createAction(
  '[QuickOrder] Create QuickOrder Flyout Items(s) fail',
  httpError()
);

export const createQuickOrderUploadItems = createAction(
  '[QuickOrder] Create QuickOrder Upload Item(s)',
  payload<{ quickOrderItems: UpdateQuickOrderItem[] }>()
);

export const createQuickOrderUploadItemsSuccess = createAction(
  '[QuickOrder] Create QuickOrder Upload Items(s) success',
  payload<{ quickOrder: QuickOrder }>()
);
export const createQuickOrderUploadItemsFail = createAction(
  '[QuickOrder] Create QuickOrder Upload Items(s) fail',
  httpError()
);

export const showQuickOrderUploadItemsSuccessMessage = createAction(
  '[QuickOrder] Show Quick Order Items Uploaded Success Message'
);
export const showQuickOrderUploadItemsWarningMessage = createAction(
  '[QuickOrder] Show Quick Order Items Uploaded Warning Message'
);
export const showQuickOrderDeleteItemsSuccessMessage = createAction(
  '[QuickOrder] Show Quick Order Items Deleted Success Message'
);
export const showQuickOrderDeleteItemsWarningMessage = createAction(
  '[QuickOrder] Show Quick Order Items Deleted Warning Message'
);
